import React, { useState } from "react";
import AlunoProfile from "../Aluno/AlunoProfile";
import AlunoLivroListAdd from "./AlunoLivroListAdd";
import { useLocation } from "react-router";

export default function AlunoLivroContainer() {
    const location = useLocation();
    const [aluno] = useState(location.state.aluno);

    return (
        <>
            <AlunoProfile aluno={aluno} />
            <div style={{ marginTop: '20px' }}>
                <AlunoLivroListAdd aluno={aluno} />
            </div>
        </>
    );
}